import { useEffect, useState } from 'react';
import { Panel } from 'reactflow';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { faFloppyDiskCircleArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentWorkflow } from 'customHooks/useCurrentWorkflow';
import { AnimatePresence, motion } from 'framer-motion';

const UnpublishedChangesPanel = () => {
    const [visible, setVisible] = useState(false);
    const { data: workflow } = useCurrentWorkflow();

    useEffect(() => {
        const timeout = setTimeout(() => setVisible(true), 1000);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <Panel position="top-right">
            <AnimatePresence>
                {workflow.has_draft_version && visible ? (
                    <motion.div
                        initial={{ y: -200 }}
                        exit={{ y: -200 }}
                        animate={{ y: 0 }}
                        transition={{ type: 'spring', duration: 0.5, bounce: 0.3 }}
                    >
                        <Box className="relative flex max-w-80 flex-col gap-2 px-5 py-4">
                            <div className="flex items-center gap-1.5">
                                <FontAwesomeIcon icon={faFloppyDiskCircleArrowRight} />
                                <p className="text-sm font-medium">Unpublished changes</p>
                            </div>

                            <p className="text-sm">
                                All changes to an active workflow will automatically be saved as a
                                draft, but will need to be republished to take effect.
                            </p>

                            <p className="text-sm">
                                Changes will only apply to future contacts entering the workflow.
                            </p>

                            <Button
                                variant="transparent"
                                size="sm"
                                shape={'square'}
                                className="absolute right-1 top-1"
                                onClick={() => setVisible(false)}
                                aria-label="Close"
                            >
                                <FontAwesomeIcon icon={faClose} size="sm" />
                            </Button>
                        </Box>
                    </motion.div>
                ) : null}
            </AnimatePresence>
        </Panel>
    );
};

export { UnpublishedChangesPanel };
